module.exports = __webpack_public_path__ + "img/persona.01991e3b.png";